import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'reactstrap';
import { useReactToPrint } from 'react-to-print';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import infracoes_api from '../../../../api/infracoes_api';
import useAlturaAutoIframe from '../../../../hooks/useAlturaAutoIframe';
import { montarSrcDocImpressao } from '../../../../helpers/htmlImpressao';

// Components
import CartaoFicha from '../../FichaImpressaoCompleta/_components/CartaoFicha';
import RodapeEmissor from '../../FichaImpressaoCompleta/_components/RodapeEmissor';
import AvisoItemSemConteudo from '../../FichaImpressaoCompleta/_components/AvisoItemSemConteudo';

const pageStyleFichaHtml = `
@page { size: auto; margin: 0mm; }
@media print { body { -webkit-print-color-adjust: exact; } }
@media print {
  @page { size:A4; margin:0; }
  .noPrint { display:none; }
}
`;

const SANDBOX_IFRAME = "allow-same-origin";

export default function FichaHtmlSeparada({ hash, parametrizacaoHash, titulo, numeroInfracao }) {
    const [item, setItem] = useState(null);
    const [erro, setErro] = useState(null);
    // O iframe só tem altura real depois do onLoad; imprimir antes disso gera página em branco.
    const [pronto, setPronto] = useState(false);
    const ref = useRef(null);
    const ajustarAltura = useAlturaAutoIframe();

    const handlePrint = useReactToPrint({
        content: () => ref.current,
        documentTitle: item?.titulo ?? "Documento",
        pageStyle: pageStyleFichaHtml
    });

    useEffect(() => {
        infracoes_api.GetImpressaoItemHtml(hash, parametrizacaoHash)
            .then(({ data }) => setItem(data))
            .catch(error => setErro(error?.message ?? "Não foi possível carregar o documento."));
    }, [hash, parametrizacaoHash]);

    if (erro)
        return <div className="p-3"><AvisoItemSemConteudo titulo={titulo ?? "Documento"} mensagem={erro} /></div>;

    if (!item) return <></>;

    return (
        <div className="d-flex flex-column p-3">
            <div className="noPrint d-flex justify-content-end mb-3">
                <Button color="danger" disabled={!pronto} onClick={handlePrint}>
                    <FontAwesomeIcon icon={faFilePdf} /> {pronto ? "Imprimir" : "Carregando..."}
                </Button>
            </div>
            <div ref={ref}>
                <CartaoFicha titulo={item.titulo}>
                    <iframe
                        title={item.titulo}
                        srcDoc={montarSrcDocImpressao(item.html)}
                        sandbox={SANDBOX_IFRAME}
                        scrolling="no"
                        style={{ width: "100%", height: 0, border: "none", display: "block", overflow: "hidden" }}
                        onLoad={(event) => { ajustarAltura(event); setPronto(true); }}
                    />
                    <RodapeEmissor numeroInfracao={numeroInfracao} />
                </CartaoFicha>
            </div>
        </div>
    );
}
